import { Account } from './account/account.types';

export * from './account/account.types';

export type AccountsResponse = {
  payload: Account[];
  error: boolean;
  type: string;
};
